module.exports = __webpack_public_path__ + "img/Baskent-Universitesi.ad2610dc.jpg";